<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->

    <h1>VueJs Test Page</h1>
    
    <h2>List of Scanned Codes</h2>
    <ul>
      <li v-for="(item, index) in this.$store.getters.getBarcodes" v-bind:key="`barcode-${index}`">{{item}}</li>
    </ul>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home'
  // components: {
  //   HelloWorld
  // }
}
</script>
